import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = {
  class: "swatches",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: "seasons",
    "aria-label": _ctx.t('homeFeaturePalettesTitle')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.t('homeFeaturePalettesTitle')), 1),
      _createElementVNode("button", {
        type: "button",
        class: "more",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToFrames && _ctx.scrollToFrames(...args)))
      }, _toDisplayString(_ctx.t('homeSeasonPreviewMore')), 1)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasons, (season) => {
        return (_openBlock(), _createElementBlock("li", {
          key: season.titleKey
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(season.swatches, (swatch) => {
              return (_openBlock(), _createElementBlock("span", {
                key: swatch,
                style: _normalizeStyle({ background: swatch })
              }, null, 4))
            }), 128))
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.t(season.titleKey)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t(season.traitKey)), 1)
        ]))
      }), 128))
    ])
  ], 8, _hoisted_1)), [
    [_directive_home_reveal]
  ])
}